import SentResetPasswordPanel from "./sentResetPasswordPanel.container";

export default SentResetPasswordPanel;
